import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { TreeItem } from '../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomProvider, ProviderChange } from '../models/providerchange';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'connect-provider-detail',
  templateUrl: 'connect-provider-detail.component.html',
  styleUrls: ['connect-provider-detail.component.scss']
})
export class ConnectProviderDetailComponent implements OnInit, OnChanges {

  public propertiesMetadata: Array<any> = [];
  public propertiesMetadataIn: Array<any> = [];
  public hidePassword: boolean = true;
  public regexEx = /^[*]+$/g;
  public regexExSpecial = /[^\w\.@-]/g;
  public providerChange: ProviderChange;
  public duplicatedKey: boolean = false;
  @Input() currentItemSelected: TreeItem;

  constructor(private _modalService: BzgModalService,
              private _connectProviderService: ConnectProviderService,
              private _toastService: BzgToastService,
              private _translateService: TranslateService,
              private _i18nService: I18nService,
              private _showToastService: ShowToastService) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.currentItemSelected) {
      this.getInfoProvider();
    }
  }

  getInfoProvider() {
    this.providerChange = new ProviderChange();
    this.providerChange.catalogObject = new CustomProvider();
    this._connectProviderService.getInfoById(this.currentItemSelected.id).subscribe((data: any) => {
      this.loadChangeSet(data);
    });
  }

  loadChangeSet(data: any) {
    this.providerChange.catalogObject.deployOnParent = data.deployOnParent ? data.deployOnParent : false;
    this.providerChange.catalogObject.id = data.id ? data.id : null;
    this.providerChange.catalogObject.name = data.name ? data.name : null;
    this.providerChange.catalogObject.type = data.type ? data.type : null;
    this.providerChange.catalogObject.parentId = data.parentId ? data.parentId : null;
    this.providerChange.catalogObject.isInProduction = data.isInProduction ? data.isInProduction : null;
    this.providerChange.catalogObject.content = data.content ? data.content : null;
    this.loadProperties(data.content.environments);
  }

  loadProperties(environments) {
    const providerProperties  = environments.find(environment =>
      environment.environment.toLowerCase() === sessionStorage.getItem('environmentType').toLowerCase()).customs;
    this.propertiesMetadata = [];
    if (providerProperties) {
      const keys = Object.keys(providerProperties);
      keys.forEach((key, index) => {
        this.propertiesMetadata.push({ key, value: providerProperties[key], position: index});
      });
      this.setFinalPropertiesMetadataValue();
    }
  }

  addProperty() {
    const currentPosition = this.propertiesMetadata.length;
    this.propertiesMetadata.push({ key: '', value: '', position: currentPosition});
  }

  public deleteProperty(value: any) {
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title: 'PROVIDERS.DELETE_ROW', message: 'PROVIDERS.DELETE_ROW_CONFIRM' }
    });
    modal.afterClosed().subscribe((result) => {
        if (result === 'delete') {
            const index = this.propertiesMetadata.indexOf(value);
            this.propertiesMetadata.splice(index, 1);
            this.setFinalPropertiesMetadataValue();
            this.fixPositioninProperties();
        }
    });
  }

  setFinalPropertiesMetadataValue() {
    this.propertiesMetadataIn = [];

    _.forEach(this.propertiesMetadata, (each) => {
      this.propertiesMetadataIn.push({ key: each.key, value: each.value, position: each.position});
    });
  }

  fixPositioninProperties() {
    this.propertiesMetadata = this.propertiesMetadata.map((each, index) => {
        return { ...each, position: index };
      });
  }

  changeProperty(value: any, position: number, isKey: boolean) {
    const itemProperty = _.find(this.propertiesMetadata, (c) => c.position === position);
    const oldProperty = _.find(this.propertiesMetadataIn, (c) => c.position === position);

    if (isKey) {
      itemProperty.key = this.removeSpaces(value);
        if (oldProperty && oldProperty.key === 'Password')
          itemProperty.value = '';
    }
    else
      itemProperty.value = value;

    if (itemProperty.key === 'Password'){
      this.providerChange.change = sessionStorage.getItem('environmentType');
    }

    this.setFinalPropertiesMetadataValue();
  }

  saveAll() {
    this.providerChange.catalogObject.content.environments.forEach(env => {
      if (env.environment.toLowerCase() === sessionStorage.getItem('environmentType').toLowerCase()) {
        env.customs = {};
        this.propertiesMetadata.forEach(property => {
          env.customs[property.key] = property.value;
        });
      }
    });
    this._connectProviderService.postInfoProvider(this.providerChange).subscribe(result => {
      this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
      this.getInfoProvider();
    });

  }

  disabledAddBtn() {
    let disabledBtnAdd = false;
    this.duplicatedKey = false;

    for (const propertyMetadata of this.propertiesMetadata) {
      const repeatedKey = this.propertiesMetadata.filter(property => property.key === propertyMetadata.key);
      if (!propertyMetadata.key || !propertyMetadata.value || repeatedKey.length > 1 || this.characterSpecial(propertyMetadata)) {
        this.duplicatedKey = true;
        disabledBtnAdd = true;
        break;
      }
    }
    return disabledBtnAdd;
  }

  characterSpecial(propertyMetadata) {
    return propertyMetadata.key.match(this.regexExSpecial);
  }

  duplicatedKeyReview(propertyMetadata) {
    let isDuplicatedKey = false;
    if (this.duplicatedKey)
    {
      const duplicatedKey = this.propertiesMetadata.filter(property => property.key === propertyMetadata.key);
      if (duplicatedKey.length > 1)
        isDuplicatedKey = true;
    }
    return isDuplicatedKey;
  }

  disabledSaveBtn () {
    return this.disabledAddBtn() || this.propertiesMetadata.length === 0;
  }

  isEncrypt(propertyMetadata) {
    return propertyMetadata.key.toLowerCase() === 'password' && (this.hidePassword || propertyMetadata.value.match(this.regexEx));
  }

  showIcon(propertyMetadata) {
    return propertyMetadata.key.toLowerCase() === 'password' && !propertyMetadata.value.match(this.regexEx) && propertyMetadata.value.length > 0;
  }

  showPassword(hidePassword: boolean) {
    this.hidePassword = hidePassword;
  }

  onCancel() {
    this.getInfoProvider();
  }

  removeSpaces(str: string): string {
    return str.replace(/\s+/g, '');
  }

  showTitle(key, value) {
    return (key.toLowerCase() !== 'password') ? value : '';
  }
}
